<template>
  <div class="configurator-modal-market-commercial">
    <b-tabs v-model="activeTab">
      <b-tab-item label="Land Mobile">
        <b-collapse class="card" :open="false" animation="slide" aria-id="hawk-u8-collapse">
          <template #trigger="props">
            <div
              class="card-header"
              role="button"
              aria-controls="hawk-u8-collapse"
              :aria-expanded="props.open">
              <p class="card-header-title">HAWK u8</p>
              <a class="card-header-icon">
                <b-icon
                  pack="far"
                  :icon="props.open ? 'chevron-down' : 'chevron-up'"
                ></b-icon>
              </a>
            </div>
          </template>

          <div class="card-content">
            <div class="content">
              <!-- Hawk u8 -->
              <div>
                <div class="pt-4 pb-4">
                  <img
                    src="@/assets/products/product-hawk-u8-rgb.png"
                    alt="HAWK u8"
                    width="220px"
                  />
                </div>
                <table class="table is-bordered is-fullwidth">
                  <thead class="has-background-white-ter">
                    <tr>
                      <th style="width: 30%">
                        <p>
                          <span>TERMINAL CONFIGURATION</span>
                        </p>
                      </th>
                      <th style="width: 20%">
                        <p>
                          <span>GEO</span>
                        </p>
                      </th>
                      <th style="width: 50%">
                        <p>
                          <span>GEO-LTE</span>
                        </p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          <span>Antenna type</span>
                        </p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data">
                          <span>
                            Full duplex, single aperture, Ku-band flat-panel
                            antenna,
                            <br />
                            electronically steered holographic beamforming array
                          </span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Scan angles</span>
                        </p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data">
                          <span>Azimuth: 360°, Elevation: +15° to +90°</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Polarization</span>
                        </p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data">
                          <span
                            >Linear, software-defined (circular capable)</span
                          >
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Receive (RX) band</span>
                        </p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data">
                          <span>10.70 G</span>
                          <span>H</span>
                          <span>z to 12.75 G</span>
                          <span>H</span>
                          <span>z</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>RX performance</span>
                        </p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data">
                          <span>G/T (broadside) 9.5 dB/K to 12 d</span
                          ><span>b/k</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Transmit (TX) band</span>
                        </p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data">
                          <span>13.75 G</span>
                          <span>H</span>
                          <span>z to 14.50 G</span>
                          <span>H</span>
                          <span>z</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>TX performance</span>
                        </p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data">
                          <span>EIRP (broadside) 46 dBW to 46.5 dBW</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Cross-pol isolation</span>
                        </p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data">
                          <span>≥25 dB</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Satellite modem</span>
                        </p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data">
                          <span>Embedded </span><span>i</span
                          ><span>Direct </span><span>iQ</span><span> 200</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Cellular modem</span>
                        </p>
                      </td>
                      <td>
                        <p class="cell-data">
                          <span>N/A</span>
                        </p>
                      </td>
                      <td>
                        <p class="cell-data">
                          <span
                            >600 Mbps (CAT 12)<br />(Global or North America and
                            public safety configurations)</span
                          >
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Interfaces</span>
                        </p>
                      </td>
                      <td>
                        <p class="cell-data">
                          <span>Ethernet</span>
                        </p>
                      </td>
                      <td>
                        <p class="cell-data">
                          <span>Ethernet &amp; Wi-Fi (802.11 b/g/n)</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Dimensions</span>
                        </p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data">
                          <span
                            >L 89.5 cm × W 89.5 cm × H 14 cm / L 35.2 in. × W
                            35.2 in. × H 5.5 in.</span
                          >
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Weight</span>
                        </p>
                      </td>
                      <td>
                        <p class="cell-data">
                          <span>33 kg / 72 lb.</span>
                        </p>
                      </td>
                      <td>
                        <p class="cell-data">
                          <span>34 k</span><span>g / 75 lb.</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Input power**</span>
                        </p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data">
                          <span>12 VDC to 36 VDC</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Power (typical, steady state)***</span>
                        </p>
                      </td>
                      <td>
                        <p class="cell-data">
                          <span>70 W</span>
                        </p>
                      </td>
                      <td>
                        <p class="cell-data">
                          <span>98 W</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Operational temperature</span>
                        </p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data">
                          <span>
                            -40 °C to +55 °C (ambient) / -40 °C to +70 °C (with
                            solar load)
                          </span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Storage temperature</span>
                        </p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data">
                          <span>-40 °C to +85 °C</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Ingress protection</span>
                        </p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data">
                          <span>IP66</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>
                          <span>Compliance</span>
                        </p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data">
                          <span>CE, FCC, Nemko, WEEE, RoHS</span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pt-4">
                <p>
                  <span>*Specifications as of 19 May 2022. Subject to change.</span>
                </p>
                <p>
                  <span>**AC input support available via accessory.</span>
                </p>
                <p>
                  <span>
                    ***Software-controlled peak power draw. User-configurable
                    to a higher threshold for very low-temperature
                    operation.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </b-collapse>

        <b-collapse class="card" :open="false" animation="slide" aria-id="hawk-u8-oneweb-collapse">
          <template #trigger="props">
            <div
              class="card-header"
              role="button"
              aria-controls="hawk-u8-oneweb-collapse"
              :aria-expanded="props.open">
              <p class="card-header-title">HAWK u8 OneWeb</p>
              <a class="card-header-icon">
                <b-icon
                  pack="far"
                  :icon="props.open ? 'chevron-down' : 'chevron-up'"
                ></b-icon>
              </a>
            </div>
          </template>

          <div class="card-content">
            <div class="content">
              <div>
                <!-- HAWK OneWeb -->
                <div class="pt-4 pb-4">
                  <img
                    src="@/assets/products/product-hawk-u8-rgb.png"
                    alt="HAWK u8"
                    width="220px"
                  />
                </div>
                <table class="table is-bordered is-fullwidth">
                  <thead class="has-background-white-ter">
                    <tr>
                      <th>TERMINAL TYPE</th>
                      <th colspan="2">OneWeb</th>
                      <th>OneWeb-LTE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <p><span>Antenna type</span></p>
                      </td>
                      <td colspan="3">
                        <p class="cell-data">
                          Full duplex, single aperture, Ku-band flat-panel antenna,<br />electronically steered holographic beamforming arrays
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>Scan angles</span></p>
                      </td>
                      <td colspan="3">
                        <p class="cell-data"><span>Azimuth: 360°, Elevation: +15° to +90°</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>Polarization</span></p>
                      </td>
                      <td colspan="3">
                        <p class="cell-data"><span>Circular, software-defined</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>Receive (RX) band</span></p>
                      </td>
                      <td colspan="3">
                        <p class="cell-data"><span>10.70 GHz to 12.75 GHz</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>RX throughput</span></p>
                      </td>
                      <td colspan="3">
                        <p class="cell-data"><span>&lt; 195 Mbps</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>Transmit (TX) band</span></p>
                      </td>
                      <td colspan="3">
                        <p class="cell-data"><span>14.00 GHz to 14.50 GHz</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>TX throughput</span></p>
                      </td>
                      <td colspan="3">
                        <p class="cell-data"><span>&lt; 32 Mbps</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>Satellite modem</span></p>
                      </td>
                      <td colspan="3">
                        <p class="cell-data"><span>Embedded OneWeb</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>Cellular modem</span></p>
                      </td>
                      <td>
                        <p class="cell-data"><span>N/A</span></p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data"><span>600 Mbps (LTE-A Pro)<br />(Global or North America and public safety configurations) </span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>Interfaces </span></p>
                      </td>
                      <td>
                        <p class="cell-data"><span>Ethernet</span></p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data"><span>Ethernet &amp; Wi-Fi (802.11b/g/n)</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>Dimensions</span></p>
                      </td>
                      <td colspan="3">
                        <p class="cell-data"><span>L 89.5 cm × W 89.5 cm × H 14 cm / L 35.2 in. × W 35.2 in. × H 5.5 in.</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>Weight</span></p>
                      </td>
                      <td>
                        <p class="cell-data"><span>29.7 kg / 65.5 lb.</span></p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data"><span>30.5 kg / 67.2 lb.</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>Input power</span></p>
                      </td>
                      <td colspan="3">
                        <p class="cell-data"><span>12 VDC to 36 VDC or 90 VAC to 305 VAC via an accessory</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>Power (typical, steady state)**</span></p>
                      </td>
                      <td>
                        <p class="cell-data"><span>95 W</span></p>
                      </td>
                      <td colspan="2">
                        <p class="cell-data"><span>125 W</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>Operational temp</span></p>
                      </td>
                      <td colspan="3">
                        <p class="cell-data"><span>-40 °C to +55 °C</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>Storage temp</span></p>
                      </td>
                      <td colspan="3">
                        <p class="cell-data"><span>-40 °C to +85 °C</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>Ingress protection</span></p>
                      </td>
                      <td colspan="3">
                        <p class="cell-data"><span>IP66</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><span>Compliance</span></p>
                      </td>
                      <td colspan="3">
                        <p class="cell-data"><span>&#9;CE, FCC, Nemko, WEEE, RoHS</span></p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pt-4">
                <p><span>*Draft specifications as of October 2022. Subject to change.</span></p>
                <p><span>**Software-controlled peak power draw. User-configurable to a higher threshold for very low-temperature operation.</span></p>
                <p><span>Warranty voided if the Hawk u8 is used in a Maritime environment.<br /><br /></span></p>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-tab-item>
      <b-tab-item label="Maritime">
        <!-- Peregrine u8 -->
        <div>
          <div class="pt-4 pb-4">
            <img
              src="@/assets/products/product-peregrine-u8-rgb.png"
              alt="PEREGRINE u8"
              width="300px"
            />
          </div>
          <table class="table is-bordered is-fullwidth">
            <thead class="has-background-white-ter">
              <tr>
                <th style="width: 30%">
                  <span>Terminal Type</span>
                </th>
                <th style="width: 20%">
                  <span>OneWeb</span>
                </th>
                <th style="width: 50%">
                  <span>OneWeb-LTE</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>
                    <span>Antenna type</span>
                  </p>
                </td>
                <td colspan="2">
                  <p class="cell-data">
                    <span
                      >Full duplex, single aperture, Ku-band flat-panel
                      antenna,<br />electronically steered holographic
                      beamforming array</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Configuration</span>
                  </p>
                </td>
                <td colspan="2">
                  <p class="cell-data">
                    <span>Dual terminal</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Polarization</span>
                  </p>
                </td>
                <td colspan="2">
                  <p class="cell-data">
                    <span>Circular, software-defined</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Receive (RX) band</span>
                  </p>
                </td>
                <td colspan="2">
                  <p class="cell-data">
                    <span>10.70 GHz to 12.75 G</span
                    ><span>Hz</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>RX throughput (per unit)</span>
                  </p>
                </td>
                <td colspan="2">
                  <p class="cell-data">
                    <span>&lt; 195 Mbps</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Transmit (TX) band</span>
                  </p>
                </td>
                <td colspan="2">
                  <p class="cell-data">
                    <span>14.00 GHz to 14.50 GHz</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>TX throughput (per unit)</span>
                  </p>
                </td>
                <td colspan="2">
                  <p class="cell-data">
                    <span>&lt; 32 Mbps</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Satellite modem</span>
                  </p>
                </td>
                <td colspan="2">
                  <p class="cell-data">
                    <span>Embedded OneWeb</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Cellular modem</span>
                  </p>
                </td>
                <td>
                  <p class="cell-data">
                    <span>N/A</span>
                  </p>
                </td>
                <td>
                  <p class="cell-data">
                    <span
                      >600 Mbps (LTE-A Pro)<br />(Global or North America and
                      public safety configurations)</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Interfaces </span>
                  </p>
                </td>
                <td>
                  <p class="cell-data">
                    <span>Ethernet</span>
                  </p>
                </td>
                <td>
                  <p class="cell-data">
                    <span>Ethernet &amp; Wi-Fi (802.11b/g/n)</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Dimensions (per unit)</span>
                  </p>
                </td>
                <td colspan="2">
                  <p class="cell-data">
                    <span>
                      L 89.5 cm × W 89.5 cm × H 14 cm / L 35.2 in. × W 35.2 in.
                      × H 5.5 in.
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Weight (per unit)</span>
                  </p>
                </td>
                <td>
                  <p class="cell-data">
                    <span>29.7 </span><span>kg / </span><span>65.5 </span
                    ><span>lb</span><span>.</span>
                  </p>
                </td>
                <td>
                  <p class="cell-data">
                    <span>30.5 </span><span>kg / </span><span>67.2 </span
                    ><span>lb</span><span>.</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Input power (per unit)</span>
                  </p>
                </td>
                <td colspan="2">
                  <p class="cell-data">
                    <span
                      >12 VDC to 36 VDC or 90 VAC to 305 VAC via an
                      accessory</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Power (typical, steady state, per unit)**</span>
                  </p>
                </td>
                <td>
                  <p class="cell-data">
                    <span>95 W</span>
                  </p>
                </td>
                <td>
                  <p class="cell-data">
                    <span>125 W</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Operational temperature</span>
                  </p>
                </td>
                <td colspan="2">
                  <p class="cell-data">
                    <span>-40 °C to +55 °C</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Storage temperature</span>
                  </p>
                </td>
                <td colspan="2">
                  <p class="cell-data">
                    <span>-40 °C to +85 °C</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Ingress protection</span>
                  </p>
                </td>
                <td colspan="2">
                  <p class="cell-data">
                    <span>IP66</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <span>Compliance</span>
                  </p>
                </td>
                <td class="6" colspan="2">
                  <p class="cell-data">
                    <span>CE, FCC, N</span><span>emko</span
                    ><span>, WEEE, R</span><span>o</span><span>HS</span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pt-4">
          <p>
            <span
              >*Draft specifications as of October 2022. Subject to
              change.</span
            >
          </p>
          <p>
            <span>
              **Software-controlled peak power draw. User-configurable to a
              higher threshold for very low-temperature operation.
            </span>
          </p>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>
<script>
import { ref } from 'vue';

export default {
  setup() {
    const activeTab = ref(0);

    return {
      activeTab,
    };
  },
};
</script>
<style lang="scss" scoped>
.configurator-modal-market-commercial {
}
</style>
